import React, { useEffect, useState } from 'react'
import AxiosAuth from '../../utility/AxiosAuth';
import ConfigApi from '../../utility/ConfigApi';
import InitInfo from '../../utility/InitInfo';
import { useTemplate } from '../../context/TemplateProvider';
import { useModal } from '../../context/ModalContext';
import { handleFormSubmit } from '../../utility/formHelpers';
import Autocomplete from '../../components/Autocomplete';

const CollectionModal=({onSubmit,customerData})=>{
    const [searchData,setSearchData]=useState();

    return (
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
      <form onSubmit={onSubmit} className="space-y-6">    
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
          Borrower Name
          </label>
          <Autocomplete data={customerData} setSearchData={setSearchData} showCol="name"/>
          <input
              type="hidden"
              name="member_sl" 
              value={searchData?.sl}
           />
        </div>
      
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Contact Number
          </label>
          <div className="mt-2">
            <input
              type="text"
              name="contact"
              placeholder="Type Contact Number"
              defaultValue={searchData?.contact}
              readOnly
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Invest Title
          </label>
          <div className="mt-2">
            <input
              type="text"
              name="title"
              placeholder="Type Invest Title"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Amount
          </label>
          <div className="mt-2">
            <input
              type="text"
              name="amount"
              placeholder="Type Amount"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Start Date
          </label>
          <div className="mt-2">
            <input
              type="date"
              name="start_date"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            End Date
          </label>
          <div className="mt-2">
            <input
              type="date"
              name="end_date"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <button type="submit"
            className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Create New
          </button>
        </div>
      </form>
    </div>
    )
  }

  
function MemberCollection() {
    const {userId} = InitInfo();
    const [isLoading, setIsLoading] = useState(false)

    const [CollectionData, setCollectionData] = useState()
    const [customerData, setCustomerData] = useState()
    const [error, setError] = useState(null)
    const {setMessage,setLoading,setHeaderText,reloadKey,setReloadKey}=useTemplate()
    const [filteredCollectionData, setFilteredCollectionData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const {setModalTitle, openModal,closeModal } = useModal();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(123)
        try {
          const data = await handleFormSubmit(ConfigApi.OTHER_INVEST_CREATE, event.currentTarget, setIsLoading, setError);
          setLoading();
          
          if (data?.error===0) {            
            closeModal()
            setReloadKey(data.reloadKey)
  
            setMessage({type: 'success', text: data?.message})
          }else{
            setMessage({type: 'error', text: data?.message})
          }
        } catch (error) {
        }
    };

    const handleOpenModal = () => {
        openModal(<CollectionModal onSubmit={handleSubmit} customerData={customerData}/>);
        setModalTitle("Create New Other Invest")
      };
      
    useEffect(()=>{
        setHeaderText('Other Invest List')
        if (userId) {
          setLoading(123);
          AxiosAuth.post(ConfigApi.OTHER_INVEST_LIST, {userId})
            .then(({data}) => {
              setLoading();
  
              if (data.error===0) {
                setCollectionData(data.data);
              }else{
                setMessage({type: 'error', text: data.message})
              }
              
            })
            .catch(err => {
              console.log(err);
            });
        }
      },[userId,reloadKey])

    useEffect(()=>{
      if (userId) {
        AxiosAuth.post(ConfigApi.BORROWER_LIST, {userId})
          .then(({data}) => {
            setLoading();

            if (data.error===0) {
              setCustomerData(data.data);
            }else{
              setMessage({type: 'error', text: data.message})
            }
            
          })
          .catch(err => {
            console.log(err);
          });
      }
    },[userId,reloadKey])

    useEffect(() => {
      if (searchTerm) {
        const filteredData = CollectionData.filter((customer) =>
          customer.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredCollectionData(filteredData);
      } else {
        setFilteredCollectionData(CollectionData);
      }
    }, [searchTerm, CollectionData]);  

    let Sl=1;
  return (
    <div>
        <div className="relative overflow-x-auto sm:rounded-lg">
            <div className="pb-4 bg-white dark:bg-gray-900">
                <label htmlFor="table-search" className="sr-only">Search</label>
                <div className="flex items-center justify-between mt-1">
                    {/* Search Bar */}
                    <div className="relative">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                            <svg
                                className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                                />
                            </svg>
                        </div>
                        <input
                            type="text"
                            id="table-search"
                            className="block pt-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Search for items"
                        />
                    </div>

                    {/* Add New Member Button */}
                    <button
                    
                        onClick={handleOpenModal}
                        type="button"
                        className="px-4 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 dark:focus:ring-blue-600"
                    >
                        Add New Invest
                    </button>
                </div>

            </div>
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                        <th scope="col" className="p-4">
                            SL
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Date
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Borrower
                        </th>
                        
                        <th scope="col" className="px-6 py-3">
                            Title
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Date Range
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Amount
                        </th>
                        
                        <th scope="col" className="px-6 py-3">
                            Interest
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {CollectionData && filteredCollectionData?.map((row)=>(
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={row.sl}>
                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {Sl++}
                        </td>
                        <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                            {row.timeIssue}
                        </th>
                        <td className="px-6 py-4">
                            {row.customer_name}
                        </td>
                       
                        <td className="px-6 py-4">
                            {row.title}
                        </td>
                        <td className="px-6 py-4">
                            {row.timeFrom} to {row.timeTo}
                        </td> 
                        <td className="px-6 py-4">
                            {row.amount}
                        </td> 
                        <td className="px-6 py-4">
                        {row.interest_rate_by} {row.interest_rate} %
                        </td>                                           
                    </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
  )
}

export default MemberCollection